import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData } from "../../helpers/fackBackend_Helper";

function* getChatrRechargeReportResponse({ payload: { searchData } }) {
  try {
    const response = yield call(
      addData,
      "/chatrRechargeReportList",
      searchData,
    );
    if (response?.response?.Status) {
      yield put(
        actions.getChatrRechargeReportRequestListSuccessful(
          response?.response?.data,
        ),
      );
    } else {
      yield put(
        actions.getChatrRechargeReportRequestListFailed(
          response?.response?.Message,
        ),
      );
    }
  } catch (error) {
    yield put(actions.getChatrRechargeReportRequestListFailed(error));
  }
}
export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.GET_CHATR_RECHARGE_REPORT_REQUEST_LIST,
      getChatrRechargeReportResponse,
    ),
  ]);
}
